import { Component, EventEmitter, Inject, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';

import { PartyContactMechanisms } from 'src/app/component/party/model/party-contact-mechanisms.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { Region } from 'src/app/model/region.model';

import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { LoginDetailStatusType } from '../../model/login-Detail-status';
import { PasswordChange } from '../../model/password-change-data-view';
import { UserModel, USERROLE } from '../../model/user';
import { AccountService } from '../../service/account.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { PCMEditInterface } from 'src/app/component/common-components/model/pcm-edit-interfacte';
import { Organization } from 'src/app/component/common-components/organizations/model/organization.model';
import { MsgModel } from 'src/app/component/common-components/msg/model/msg.model';
import { ConfirmChangesComponent } from 'src/app/component/common-components/confirm-changes/confirm-changes.component';

import { Role, RoleSelection } from 'src/app/model/roles';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { timer } from 'rxjs';
import { DistrictDropdownTwoWayComponent } from 'src/app/component/common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { RegionDropdownTwoWayComponent } from 'src/app/component/common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';

@Component({
    selector: 'app-edit-account',
    templateUrl: './edit-account.component.html',
    styleUrls: ['./edit-account.component.scss']
})
export class EditAccountComponent implements OnInit {
    @ViewChild(DistrictDropdownTwoWayComponent) districtDropDown!: DistrictDropdownTwoWayComponent;
    @ViewChild(RegionDropdownTwoWayComponent) regionDropDown!: RegionDropdownTwoWayComponent;
    contactInfoForm: UntypedFormGroup;
    userRoleFormGroup: UntypedFormGroup;

    selectedRegion: Region;
    selectedRegions: Region[] = [];
    selectedOrganization: Organization;
    lstSelecteddistricts: SchoolDistrict[] = [];
    msg: MsgModel = new MsgModel();

    loginDetailStatusName: string = '';
    revokeCtrHide: boolean = false;
    passwordChangeInformation: PasswordChange;
    loginDetailStatusType: LoginDetailStatusType[] = [];
    partyContactMechanisms: PartyContactMechanisms[] = [];
    partyIdNum!: number;

    profileChanged: boolean = false;
    districtRefresh: boolean = false;
    //common Control variables
    lstEditedPcm: PartyContactMechanisms[] = [];
    lstRemovedPcm: PartyContactMechanisms[] = [];
    lstSelectedDistrictIds: number[] = [];

    lstSelectedUserRole: USERROLE[] = [];
    lstUserRoles: RoleSelection[] = [];
    lstApproverRole: RoleSelection[] = [];
    lstAdminRoles: RoleSelection[] = [];

    user: UserModel;
    editUserPayload: any = {};

    success: string = '';
    isSaving: boolean = false;
    featurePermissions: any;
    featuresCheck: string[] = [
        'Edit Account Status',
        'Edit Account Contact Information'
    ];
    editAccountStatus: boolean = false;
    editAccountContactInformation: boolean = false;
    systemAdministratorUser: boolean = false;
    constructor(
        private fb: UntypedFormBuilder,
        public accountService: AccountService,
        public apiSchoolService: ApiSchoolsService,
        public dialogRef: MatDialogRef<EditAccountComponent>,
        public accessService: AccessService,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public userModel: UserModel
    ) {
        this.contactInfoForm = this.fb.group({
            accountStatus: ['', [Validators.required]],
            reasonRevoking: [{ visible: false }],
            reasonComment: [''],
            firstName: ['', [Validators.required]],
            middleName: [''],
            lastName: ['', [Validators.required]],
            suffix: [''],
            workTitle: ['', [Validators.required]],
            workEmail: ['', [Validators.email, Validators.required]]
        });

        this.getPartyContactMechanisms(this.userModel.PERSON.PARTIES_ID);
        this.reset();

        //this.lstSelectedDistrictIds = this.lstSelecteddistricts.map((x) => x.ID);
    }
    ngOnInit(): void {
        this.districtRefresh = true;
        this.getFeaturePermissions();
        this.getLoginDetailStatusTypes();
        this.getPasswordChangeInformation(this.user.ID);
    }

    getFeaturePermissions() {
        this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
            this.featurePermissions = res;
            if (this.featurePermissions['Edit Account Status']) {
                this.editAccountStatus = true;
            }
            if (this.featurePermissions['Edit Account Contact Information']) {
                this.editAccountContactInformation = true;
            }

        });

        this.accessService.systemAdministratorUser().subscribe((adminUser: boolean) => {
            this.systemAdministratorUser = adminUser;
        });


    }

    regionEventEmitter(lstRegion: Region[]) {
        this.selectedRegion = lstRegion[0];

        if (this.selectedRegion?.ID! > 0 && this.selectedRegion.ID != this.user.REGION?.ID) {
            this.lstSelectedDistrictIds = [];
            this.districtDropDown.deSelectAll();
        }
    }

    districtsEventEmitter(districts: SchoolDistrict[]) {
        this.lstSelecteddistricts = districts;
    }

    notifyChildStatus() {
        this.lstEditedPcm = [] = [];
        this.lstRemovedPcm = [] = [];
        this.editUserPayload = {};
    }
    onStatusChange(e: MatSelectChange) {
        if (e.value == 2) {
            this.showReasonRevokingCtrls(true);
            this.reasonRevoking.setValue(this.user.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES.ID);
            //this.reasonComment.setValue(this.user.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES.DESCRIPTION);
            this.reasonRevoking.setValidators(Validators.required);
            this.reasonComment.setValidators(Validators.required);
        } else {
            this.reasonRevoking.clearValidators();
            this.reasonRevoking.updateValueAndValidity();
            this.reasonComment.clearValidators();
            this.reasonComment.updateValueAndValidity();
            this.showReasonRevokingCtrls(false);
        }
    }
    showReasonRevokingCtrls(hide: boolean) {
        this.revokeCtrHide = hide;
        this.loginDetailStatusName = this.revokeCtrHide ? 'Inactive' : 'Active';
    }

    pcmNotificationChange(event: PCMEditInterface, type: string) {
        switch (type) {
            case 'Address':
                if (event.deletePartyContactMechanisms != undefined && event.deletePartyContactMechanisms?.ID! >= 1)
                    this.lstRemovedPcm.push(event.deletePartyContactMechanisms);

                if (event.editpartyContactMechanisms != undefined && event.editpartyContactMechanisms.length >= 0) {
                    event.editpartyContactMechanisms.forEach((x) => this.lstEditedPcm.push(x));
                }

                break;
            case 'Phone':
                if (event.deletePartyContactMechanisms != undefined && event.deletePartyContactMechanisms.ID! >= 1)
                    this.lstRemovedPcm.push(event.deletePartyContactMechanisms);

                if (event.editpartyContactMechanisms != undefined && event.editpartyContactMechanisms.length >= 0) {
                    event.editpartyContactMechanisms.forEach((x) => this.lstEditedPcm.push(x));
                }
                break;
            default:
                break;
        }

        /*if (
            this.partyContactMechanisms?.length >= 0 &&
            this.lstEditedPcm?.length >= 0 &&
            this.lstEditedPcm.findIndex((x) => x.CONTACT_MECHANISMS?.CONTACT_MECHANISM_TYPES?.TYPE != type) == -1
        ) {
            this.partyContactMechanisms
                .filter((x) => x.CONTACT_MECHANISMS?.CONTACT_MECHANISM_TYPES?.TYPE != type)
                .forEach((originalPcm) => {
                    this.lstEditedPcm.push(originalPcm);
                });
        }*/
    }

    removeDistrict(districtId: number) {
        let lstSchoolDistrictId: number[] = this.lstSelecteddistricts.filter((x) => x.ID != districtId).map((y) => y.ID);

        if (lstSchoolDistrictId?.length > 0) {
            this.districtDropDown.deSelectAll();
            this.districtDropDown.select(lstSchoolDistrictId);
            this.districtDropDown.emitSelect(lstSchoolDistrictId);
        } else {
            this.districtDropDown.deSelectAll();
            this.districtDropDown.select([]);
            this.districtDropDown.emitSelect(lstSchoolDistrictId);
        }
    }

    isDisabled() {
        if (this.contactInfoForm.dirty && this.contactInfoForm.valid) return false;
        else if (this.lstEditedPcm?.length > 0 || this.lstRemovedPcm?.length > 0) return false;
        else if (this.organizationChange()) return false;
        else if (this.removedItemUserRoles()?.length > 0) return false;
        else if (this.user.USER_ROLES?.length !== this.lstSelectedUserRole?.length) return false;
        else {
            return true;
        }
    }
    organizationChange() {
        const diff = [
            ...this.getDifference(
                this.lstSelectedDistrictIds,
                this.lstSelecteddistricts.map((x) => x.ID)
            ),
            ...this.getDifference(
                this.lstSelecteddistricts.map((x) => x.ID),
                this.lstSelectedDistrictIds
            )
        ];

        //change detection for Region/Organization
        if (
            diff?.length > 0 ||
            (this.selectedOrganization.ID! > 0 && this.selectedOrganization.ID != this.user?.WORKS_FOR?.ID) ||
            this.selectedRegion?.ID! != this.user.REGION?.ID!
        )
            return true;
        else return false;
    }
    save() {
        let removedItems = this.removedItemUserRoles();
        this.isSaving = true;
        if (this.organizationChange()) {
            let sD: SchoolDistrict[] = [];
            this.lstSelecteddistricts.forEach((element) => {
                let newSchoolDistrict: SchoolDistrict = new SchoolDistrict();
                newSchoolDistrict.ID = element.ID;
                newSchoolDistrict.ORGANIZATIONS_ID = element.ORGANIZATIONS_ID;
                newSchoolDistrict.NCESDist = element.NCESDist;
                newSchoolDistrict.DISTRICTS = element.DISTRICTS;
                newSchoolDistrict.CODE = element.CODE;
                newSchoolDistrict.ORGANIZATION = element.ORGANIZATION;

                sD.push(newSchoolDistrict);
            });
            this.user.REGION = this.selectedRegion;
            this.user.SCHOOL_DISTRICTS = sD;
            this.user.WORKS_FOR = this.selectedOrganization;

            this.accountService.updateRegionOrganization(this.user).subscribe((x) => {
                this.msg = x['msg'];
                if (this.msg.SUCCESS) {
                    this.success = "Successfully updated user's Region and 'works for' Organization.";
                    this.userModel = this.user;
                    this.reset();
                }
            });
        }
        if ((this.contactInfoForm.dirty && this.contactInfoForm.valid) || this.lstEditedPcm?.length > 0 || this.lstRemovedPcm?.length > 0) {
            //CONTACT INFORMATION CHANGES
            if (this.contactInfoForm.dirty && this.contactInfoForm.valid) {
                const keyValue = Object.entries(this.contactInfoForm.controls).filter((value) => value[1].dirty);
                keyValue.forEach((x) => {
                    switch (x[0]) {
                        case 'accountStatus':
                            this.user.LOGIN_DETAIL_STATUS[0].ID = 0;
                            if (x[1].value === 1) {
                                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES = this.loginDetailStatusType.find((x) => x.ID == 1)!;
                                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES_ID = 1;
                            } else {
                                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES = this.loginDetailStatusType.find(
                                    (x) => x.ID === +this.reasonRevoking.value
                                )!;
                                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES_ID = +this.reasonRevoking.value;
                                this.user.LOGIN_DETAIL_STATUS[0].DESCRIPTION=this.reasonComment.value
                                //this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES.DESCRIPTION = this.reasonComment.value;
                            }
                            break;
                        case 'firstName':
                            this.user.PERSON.FIRST_NAME = this.firstName.value;
                            break;
                        case 'middleName':
                            this.user.PERSON.MIDDLE_INITIAL = this.middleName.value;
                            break;
                        case 'lastName':
                            this.user.PERSON.LAST_NAME = this.lastName.value;
                            break;
                        case 'suffix':
                            this.user.PERSON.SUFFIX = this.suffix.value;
                            break;
                        case 'workTitle':
                            this.user.WORK_TITLE = this.workTitle.value;
                            break;
                        case 'workEmail':
                            this.user.EMAIL_ADDRESS = this.workEmail.value;
                            break;
                        default:
                            break;
                    }
                });
            }

            if (this.lstEditedPcm?.length <= 0 && this.lstRemovedPcm?.length <= 0)
                this.editUserPayload = { editUser: this.user, partyContactMechanisms: this.partyContactMechanisms };
            else this.editUserPayload = { editUser: this.user, partyContactMechanisms: this.lstEditedPcm, deletePartyContactMechanisms: this.lstRemovedPcm };

            if (this.editAccountContactInformation) {
                this.accountService.updateAccountContactInfo(this.editUserPayload).subscribe((x) => {
                    this.userModel = x['editUser'];
                    this.success = "Account's contact information has successfully been updated.";
                    if (this.lstEditedPcm?.length <= 0 || this.lstRemovedPcm?.length < 0) {
                        this.reset();
                    } else {
                        this.getPartyContactMechanisms(this.userModel.PERSON.PARTIES_ID);
                        this.notifyChildStatus();
                    }
                });
            }
            else {
                this.accountService.updateAccountStatus(this.editUserPayload).subscribe((x) => {
                    this.userModel = x['editUser'];
                    this.success = "Account's contact information has successfully been updated.";
                    if (this.lstEditedPcm?.length <= 0 || this.lstRemovedPcm?.length < 0) {
                        this.reset();
                    } else {
                        this.getPartyContactMechanisms(this.userModel.PERSON.PARTIES_ID);
                        this.notifyChildStatus();
                    }
                });
            }
        }

        if (this.removedItemUserRoles().length > 0 || this.lstSelectedUserRole?.length != this.user.USER_ROLES?.length) {
            this.user.USER_ROLES = this.lstSelectedUserRole;
            this.editUserPayload = { user: this.user, deleteUserRoles: removedItems };
            this.accountService.UpdateUserRoles(this.editUserPayload).subscribe((x) => {
                this.msg = x['msg'];
                if (this.msg.SUCCESS) {
                    this.success = "Successfully updated user's roles.";
                    this.isSaving = false;
                    this.notifyChildStatus();
                }
            });
        }

        const s = timer(5000);
        s.subscribe((val) => {
            this.success = '';
            this.isSaving = false;
        });
    }
    reset() {
        this.user = {} as UserModel;
        this.user = this.userModel;
        this.isSaving = false;
        this.loginDetailStatusName =
            this.user.LOGIN_DETAIL_STATUS == null ||
                this.user.LOGIN_DETAIL_STATUS.length <= 0 ||
                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES == null ||
                this.user.LOGIN_DETAIL_STATUS[0].LOGIN_DETAIL_STATUS_TYPES.NAME == null
                ? ''
                : this.user.LOGIN_DETAIL_STATUS[0]?.LOGIN_DETAIL_STATUS_TYPES?.NAME?.toString();

        this.setContanctInformation();
        this.lstEditedPcm = [] = [];
        this.lstRemovedPcm = [] = [];
        this.editUserPayload = {};

        let tempPartyContactMechanisms = [...this.partyContactMechanisms];
        this.partyContactMechanisms = [...tempPartyContactMechanisms];

        this.selectedRegion = new Region();
        this.selectedOrganization = new Organization();

        this.lstSelectedDistrictIds = [];
        this.lstSelecteddistricts = [];


        setTimeout(() => {
            if (this.regionDropDown) {
                let regionIds: number[] = [];
                regionIds[0] = this.user?.REGION?.ID!;
                this.regionDropDown.deSelectAll();
                this.regionDropDown.select(regionIds);
                this.regionDropDown.emitSelect(regionIds);
            }
            if (this.districtDropDown) {
                this.districtDropDown.deSelectAll();
                this.districtDropDown.select(this.lstSelectedDistrictIds);
                this.districtDropDown.emitSelect(this.lstSelectedDistrictIds);
            }
            this.user.SCHOOL_DISTRICTS.forEach((sD) => {
                if (this.lstSelectedDistrictIds.findIndex((id) => id == sD.ID!) < 0) {
                    this.lstSelectedDistrictIds.push(sD.ID!);
                    let d: SchoolDistrict = new SchoolDistrict();
                    d.ID = sD.ID || 0;
                    d.DISTRICTS = sD.DISTRICTS!;
                    this.lstSelecteddistricts.push(d);
                }
            });
        }, 1000);

        this.selectedOrganization.ID = this.user?.WORKS_FOR?.ID;
        this.selectedOrganization.PARTIES_ID = this.user?.WORKS_FOR?.PARTIES_ID;
        this.lstSelectedUserRole = [...this.user.USER_ROLES];
        this.getRoles();
    }

    cancel() {
        if (this.contactInfoForm.dirty || this.lstEditedPcm?.length > 0 || this.lstRemovedPcm?.length > 0) {
            this.openDialog('Are you sure you want to discard the contact information changes?');
        } else if (this.organizationChange()) {
            this.openDialog('Are you sure you want to discard the organization changes?');
        } else this.dialogRef.close(this.user);
    }

    setContanctInformation() {
        this.contactInfoForm.reset();
        this.firstName.setValue(this.user.PERSON.FIRST_NAME);
        this.middleName.setValue(this.user.PERSON.MIDDLE_INITIAL);
        this.lastName.setValue(this.user.PERSON.LAST_NAME);
        this.suffix.setValue(this.user.PERSON.SUFFIX);
        this.workTitle.setValue(this.user.WORK_TITLE);
        this.workEmail.setValue(this.user.EMAIL_ADDRESS);

        if (this.loginDetailStatusName == 'Active') {
            this.accountStatus.setValue(1);
            this.onStatusChange(this.accountStatus);
        }
        if (this.loginDetailStatusName != 'Active') {
            this.accountStatus.setValue(2);
            this.onStatusChange(this.accountStatus);
        }
    }

    ///User Roles

    onChkChange(ob: MatCheckboxChange, role: Role) {
        if (ob.checked) {
            if (this.lstSelectedUserRole.findIndex((x) => x.ROLE.ID == role.ID) < 0) {
                const ur = {} as USERROLE;
                ur.ROLE = role;
                this.lstSelectedUserRole.push(ur);
            }
        } else {
            this.lstSelectedUserRole = this.lstSelectedUserRole.filter((x) => x.ROLE.ID != role.ID);
        }
    }
    removedItemUserRoles(): USERROLE[] {
        let removeUserRoleItem: USERROLE[] = [];
        this.user.USER_ROLES.forEach((ur) => {
            if (this.lstSelectedUserRole.findIndex((x) => x.ROLE.ID === ur.ROLE.ID) == -1) {
                removeUserRoleItem.push(ur);
            }
        });
        return removeUserRoleItem;
    }

    openDialog(msg: string) {
        const dialogRef = this.dialog.open(ConfirmChangesComponent, {
            width: '500px',
            data: { msg: msg }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result['closed'] == true) {
                this.dialogRef.close();
            }
        });
    }

    getRoles() {
        this.lstUserRoles = [];
        this.lstApproverRole = [];
        this.lstAdminRoles = [];
        this.accessService.getRoles().subscribe((roles: Role[]) => {
            roles = roles.filter((x) => x.ACTIVE != 0);
            roles
                .filter((x) => x.NAME.indexOf('Approver') < 0 && x.NAME.indexOf('Administrator') < 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    if (this.user.USER_ROLES.findIndex((userRole) => userRole.ROLE.ID === item.ID) >= 0) this.lstUserRoles.push({ selected: true, role: item });
                    else this.lstUserRoles.push({ selected: false, role: item });
                });

            roles
                .filter((x) => x.NAME.indexOf('Approver') > 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    if (this.user.USER_ROLES.findIndex((userRole) => userRole.ROLE.ID === item.ID) >= 0)
                        this.lstApproverRole.push({ selected: true, role: item });
                    else this.lstApproverRole.push({ selected: false, role: item });
                });
            roles
                .filter((x) => x.NAME.indexOf('Administrator') > 0)
                .sort((a, b) => {
                    return b.NAME.toString().toLocaleLowerCase() > a.NAME.toString().toLocaleLowerCase() ? -1 : 1;
                })
                .forEach((item) => {
                    if (this.user.USER_ROLES.findIndex((userRole) => userRole.ROLE.ID === item.ID) >= 0)
                        this.lstAdminRoles.push({ selected: true, role: item });
                    else this.lstAdminRoles.push({ selected: false, role: item });
                });
        });
    }
    getPasswordChangeInformation(id: number) {
        this.accountService.getPasswordChangeInformation(id).subscribe((x) => (this.passwordChangeInformation = x));
    }
    getLoginDetailStatusTypes() {
        this.accountService.getLoginDetailStatusTypes().subscribe((x) => (this.loginDetailStatusType = x));
    }
    getPartyContactMechanisms(PARTIES_ID: number) {
        this.apiSchoolService.getPartyContactMechanisms({ id: PARTIES_ID }).subscribe((x: any) => {
            this.partyContactMechanisms = x['partyContactMechanisms'] as PartyContactMechanisms[];
            this.notifyChildStatus();
        });
    }
    getDifference<T>(a: T[], b: T[]): T[] {
        return a.filter((element) => {
            return !b.includes(element);
        });
    }

    //get Attributes
    get accountStatus(): any {
        return this.contactInfoForm.get('accountStatus');
    }
    get reasonRevoking(): any {
        return this.contactInfoForm.get('reasonRevoking');
    }
    get reasonComment(): any {
        return this.contactInfoForm.get('reasonComment');
    }
    get firstName(): any {
        return this.contactInfoForm.get('firstName');
    }
    get middleName(): any {
        return this.contactInfoForm.get('middleName');
    }
    get lastName(): any {
        return this.contactInfoForm.get('lastName');
    }
    get suffix(): any {
        return this.contactInfoForm.get('suffix');
    }
    get workTitle(): any {
        return this.contactInfoForm.get('workTitle');
    }
    get workEmail(): any {
        return this.contactInfoForm.get('workEmail');
    }
    //end attributes

    //User Roles
}
